"use client";

import { useApiGet } from "@/hooks/use-api";
import { integrationKeys } from "./keys";
import type { LinearConnectionStatus } from "./types";

/**
 * useLinearStatus
 *
 * Linear connection status for the current workspace. Gated on workspaceId
 * so the request never fires with an empty one (the backend 400s that).
 */
export function useLinearStatus(workspaceId: string | undefined) {
  const safeId = workspaceId ?? "";

  const { data, isLoading, isError, refetch } =
    useApiGet<LinearConnectionStatus>(
      integrationKeys.linear(safeId),
      `/api/linear/status?workspaceId=${encodeURIComponent(safeId)}`,
      undefined,
      {
        enabled: !!safeId,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
      },
    );

  return {
    connected: data?.connected ?? false,
    userEmail: data?.userEmail,
    isLoading,
    isError,
    refetch,
  };
}
